var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading_message"},[_c('svgicon',{staticClass:"loading_message__icon",attrs:{"icon":"loading","width":"64","height":"64"}}),(_vm.message)?_c('p',[_vm._v(_vm._s(_vm.message))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }